import "./SettingsPageContainer.scss";

import React from "react";

type SettingsContainerPropTypes = {
  header?: React.ReactNode;
  children?: React.ReactNode;
  childrenLeft?: React.ReactNode;
  childrenRight?: React.ReactNode;
};

const SettingsPageContainer = ({
  header,
  children,
  childrenRight,
  childrenLeft,
}: SettingsContainerPropTypes) => {
  return (
    <>
      {children}
      <div className="SettingsPageContainer swim-wrapper h-100">
        {header && (
          <div className="SettingsPageContainer__Header">{header}</div>
        )}
        <div
          className={`grid-layout gl-2 no-gap-tb swimlanes msa-medical-split w-100`}
        >
          <div className="swim-headers">Settings Information</div>
          <div className="swim-headers">Notes + Documents</div>
          <div className="swim-column">{childrenLeft}</div>
          <div className="swim-column">{childrenRight}</div>
        </div>
      </div>
    </>
  );
};

export default SettingsPageContainer;
